module.exports = __webpack_public_path__ + "img/hist2.528b4f13.png";